module.exports = __webpack_public_path__ + "static/media/smorja.31f7d809.mp3";